/** Deep-link to a catalog entry on `/faq`. */
export function faqEntryHref(entryId: string): string {
  const id = entryId.replace(/^#/, "").trim();
  return id ? `/faq#${id}` : "/faq";
}
